import getOwfTOSArticleData from "@faire/web-api--source/api/small-business-grant/tos-info/get";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";

import { DataByLocale } from "@faire/retailer/lib/localization";

export const getOwfGrantTOSArticleData = async (): Promise<DataByLocale> => {
  const data = await getOwfTOSArticleData();

  return {
    linkOrId: data.terms_of_service_article?.id ?? "",
    locale: data.terms_of_service_article?.zendesk_locale as Language,
  };
};
